import { create } from "zustand";

type Workflow = {
  id: string;
  name: string;
  description: string;
  version: string;
  status: string;
  isPublic: boolean;
  isDraft: boolean;
  createdAt: string;
  updatedAt: string;
  workflow: any;
  error?: string;
};

type AgentState = {
  activeAgentId: string | null;
  agentIds: string[];
  workflows: Workflow[];
  isLoadingWorkflows: boolean;
  workflowsError: string | null;
};

type AgentStore = AgentState & {
  updateAgentStore: (
    partial: Partial<AgentState> | ((prev: AgentState) => Partial<AgentState>),
  ) => void;
};

export const useAgentStore = create<AgentStore>()((set) => ({
  activeAgentId: null,
  agentIds: [],
  workflows: [],
  isLoadingWorkflows: false,
  workflowsError: null,
  updateAgentStore: (partial) =>
    set((state) => {
      const prev: AgentState = {
        activeAgentId: state.activeAgentId,
        agentIds: state.agentIds,
        workflows: state.workflows,
        isLoadingWorkflows: state.isLoadingWorkflows,
        workflowsError: state.workflowsError,
      };
      const patch = typeof partial === "function" ? partial(prev) : partial;
      return { ...patch };
    }),
}));

export type { AgentState, AgentStore, Workflow };
